import React from 'react';
import { 
  Calendar, 
  Heart, 
  Sparkles, 
  Leaf, 
  Target, 
  DollarSign, 
  BookOpen, 
  Palette, 
  TrendingUp, 
  Moon, 
  Sun, 
  Droplets, 
  Smile, 
  Brain, 
  Scale, 
  Image, 
  CheckCircle, 
  Clock, 
  Star,
  Home,
  User,
  Settings,
  Plus,
  Edit,
  Trash2,
  ChevronRight,
  ChevronLeft,
  Search,
  Filter,
  MoreHorizontal
} from 'lucide-react';

interface IconProps {
  size?: number;
  className?: string;
}

export const ModernIcons = {
  // Navigation
  Home: ({ size = 20, className = "" }: IconProps) => <Home size={size} className={`text-gray-600 ${className}`} />,
  User: ({ size = 20, className = "" }: IconProps) => <User size={size} className={`text-gray-600 ${className}`} />,
  Settings: ({ size = 20, className = "" }: IconProps) => <Settings size={size} className={`text-gray-600 ${className}`} />,
  
  // Main sections
  Calendar: ({ size = 24, className = "" }: IconProps) => <Calendar size={size} className={`text-gray-700 ${className}`} />,
  Heart: ({ size = 24, className = "" }: IconProps) => <Heart size={size} className={`text-gray-700 ${className}`} />,
  Sparkles: ({ size = 24, className = "" }: IconProps) => <Sparkles size={size} className={`text-gray-700 ${className}`} />,
  Leaf: ({ size = 24, className = "" }: IconProps) => <Leaf size={size} className={`text-gray-700 ${className}`} />,
  
  // Planner icons
  Target: ({ size = 20, className = "" }: IconProps) => <Target size={size} className={`text-gray-600 ${className}`} />,
  DollarSign: ({ size = 20, className = "" }: IconProps) => <DollarSign size={size} className={`text-gray-600 ${className}`} />,
  CheckCircle: ({ size = 20, className = "" }: IconProps) => <CheckCircle size={size} className={`text-gray-600 ${className}`} />,
  Clock: ({ size = 20, className = "" }: IconProps) => <Clock size={size} className={`text-gray-600 ${className}`} />,
  
  // Health icons
  Moon: ({ size = 20, className = "" }: IconProps) => <Moon size={size} className={`text-gray-600 ${className}`} />,
  Sun: ({ size = 20, className = "" }: IconProps) => <Sun size={size} className={`text-gray-600 ${className}`} />,
  Droplets: ({ size = 20, className = "" }: IconProps) => <Droplets size={size} className={`text-gray-600 ${className}`} />,
  Smile: ({ size = 20, className = "" }: IconProps) => <Smile size={size} className={`text-gray-600 ${className}`} />,
  
  // Self-development icons
  BookOpen: ({ size = 20, className = "" }: IconProps) => <BookOpen size={size} className={`text-gray-600 ${className}`} />,
  Palette: ({ size = 20, className = "" }: IconProps) => <Palette size={size} className={`text-gray-600 ${className}`} />,
  TrendingUp: ({ size = 20, className = "" }: IconProps) => <TrendingUp size={size} className={`text-gray-600 ${className}`} />,
  Star: ({ size = 20, className = "" }: IconProps) => <Star size={size} className={`text-gray-600 ${className}`} />,
  
  // Wellness icons
  Brain: ({ size = 20, className = "" }: IconProps) => <Brain size={size} className={`text-gray-600 ${className}`} />,
  Scale: ({ size = 20, className = "" }: IconProps) => <Scale size={size} className={`text-gray-600 ${className}`} />,
  Image: ({ size = 20, className = "" }: IconProps) => <Image size={size} className={`text-gray-600 ${className}`} />,
  
  // Actions
  Plus: ({ size = 20, className = "" }: IconProps) => <Plus size={size} className={`text-gray-600 ${className}`} />,
  Edit: ({ size = 20, className = "" }: IconProps) => <Edit size={size} className={`text-gray-600 ${className}`} />,
  Trash2: ({ size = 20, className = "" }: IconProps) => <Trash2 size={size} className={`text-gray-600 ${className}`} />,
  Search: ({ size = 20, className = "" }: IconProps) => <Search size={size} className={`text-gray-600 ${className}`} />,
  Filter: ({ size = 20, className = "" }: IconProps) => <Filter size={size} className={`text-gray-600 ${className}`} />,
  MoreHorizontal: ({ size = 20, className = "" }: IconProps) => <MoreHorizontal size={size} className={`text-gray-600 ${className}`} />,
  
  // Navigation arrows
  ChevronRight: ({ size = 20, className = "" }: IconProps) => <ChevronRight size={size} className={`text-gray-600 ${className}`} />,
  ChevronLeft: ({ size = 20, className = "" }: IconProps) => <ChevronLeft size={size} className={`text-gray-600 ${className}`} />,
};
